import { render, staticRenderFns } from "./modalAddYouTubeSetup.vue?vue&type=template&id=1bfb9a46&"
import script from "./modalAddYouTubeSetup.vue?vue&type=script&lang=js&"
export * from "./modalAddYouTubeSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports